export type QrLoginSseEventType = "ISSU" | "SCAN" | "APRV" | "RJCT" | "EXPR" | "message";
type QrLoginSseHandler = (eventType: QrLoginSseEventType, data: any) => void;
type QrLoginSseErrorHandler = (readyState: number) => void;

const parseSseData = (data: string) => {
    try {
        return JSON.parse(data);
    } catch {
        return data;
    }
};

const AthnQrLoginSseApi = (
    onMessage: QrLoginSseHandler,
    onError?: QrLoginSseErrorHandler,
    onOpen?: () => void,
) => {
    const baseUrl = process.env.REACT_APP_MGP_BASE_URL || "/api/";
    const sseUrl = `${baseUrl.replace(/\/$/, "")}/athn/qr/login/sse`;
    const eventSource = new EventSource(sseUrl, { withCredentials: true });

    if(onOpen) {
        eventSource.onopen = onOpen;
    }

    (["ISSU", "SCAN", "APRV", "RJCT", "EXPR"] as const).forEach((eventType) => {
        eventSource.addEventListener(eventType, (event) => {
            onMessage(eventType, parseSseData(event.data));
        });
    });

    eventSource.onmessage = (event) => {
        onMessage("message", parseSseData(event.data));
    };

    if(onError) {
        eventSource.onerror = () => onError(eventSource.readyState);
    }

    return eventSource;
}
export default AthnQrLoginSseApi;